var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialSecurity1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_12758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 10.5473V11.9064C17.2275 12.677 17.4099 13.4366 17.7597 14.1232C18.1096 14.8098 18.6169 15.4038 19.2403 15.8567L24.926 19.9876C25.0928 20.1088 25.2938 20.1741 25.5 20.1741C25.7062 20.1741 25.9072 20.1088 26.074 19.9876L31.7597 15.8567C32.3831 15.4038 32.8904 14.8098 33.2403 14.1232C33.5901 13.4366 33.7725 12.677 33.7725 11.9064V4.31445C33.7725 2.96611 32.6794 1.87305 31.3311 1.87305H19.6689C18.3206 1.87305 17.2275 2.96611 17.2275 4.31445V7.1293",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2037 31.133C39.063 29.3677 37.5868 27.9787 35.7854 27.9787H32.7707C30.8762 27.9787 29.3403 29.5146 29.3403 31.4092V32.722M30.3989 39.4531H33.7442M17.2554 39.4531H20.5234M21.6594 32.6492V31.4091C21.6594 29.5145 20.1235 27.9786 18.2289 27.9786H15.2143C13.4127 27.9786 11.9366 29.3677 11.7959 31.1329M24.5919 13.9062C24.398 13.9063 24.2061 13.8681 24.027 13.7939C23.8478 13.7197 23.6851 13.6109 23.548 13.4738L20.5626 10.4884C19.9861 9.91191 19.9861 8.97715 20.5626 8.40068C21.1392 7.82422 22.0738 7.82402 22.6503 8.40068L24.5919 10.3423L28.3493 6.58477C28.9259 6.0083 29.8605 6.00811 30.437 6.58477C31.0135 7.16123 31.0135 8.0959 30.437 8.67246L25.6357 13.4739C25.3589 13.7507 24.9834 13.9062 24.5919 13.9062Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2532 35.7934L6.95884 32.499C5.66997 31.2102 5.66997 29.1206 6.95884 27.8318C7.38306 27.4076 8.07085 27.4076 8.49507 27.8318L14.9304 34.2672M30.3996 39.4533V35.1991C30.3996 33.3046 28.8637 31.7687 26.9691 31.7687H23.9544C22.0599 31.7687 20.5241 33.3045 20.5241 35.1991V39.4533H30.3996Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33018 38.9704L9.27852 41.9188C9.50698 42.1472 9.68821 42.4185 9.81185 42.717C9.9355 43.0155 9.99913 43.3354 9.99912 43.6585V47.6401C9.99912 47.7696 10.0506 47.8938 10.1421 47.9853C10.2337 48.0769 10.3579 48.1283 10.4874 48.1283H16.7674C16.8969 48.1283 17.0211 48.0769 17.1127 47.9853C17.2042 47.8938 17.2557 47.7696 17.2557 47.6401V38.2241C17.2557 37.7072 17.1538 37.1953 16.956 36.7177C16.7582 36.2401 16.4682 35.8061 16.1026 35.4405L8.49473 27.8326C8.07324 27.4112 7.38789 27.4057 6.96514 27.8259C6.82663 27.964 6.70059 28.1141 6.58848 28.2743V21.106C6.58848 19.015 4.89834 17.3188 2.80967 17.3089C1.94229 17.3046 1.23242 18.0049 1.23242 18.8723V32.1398C1.23245 33.2493 1.67323 34.3135 2.45781 35.0981L3.91338 36.5536M33.7443 44.5321V47.64C33.7443 47.7695 33.7958 47.8937 33.8874 47.9852C33.9789 48.0768 34.1031 48.1282 34.2326 48.1282H40.5126C40.6421 48.1282 40.7663 48.0768 40.8579 47.9852C40.9494 47.8937 41.0009 47.7695 41.0009 47.64V43.6584C41.0009 43.0059 41.2601 42.3801 41.7215 41.9187L48.5422 35.098C49.3268 34.3134 49.7676 33.2492 49.7676 32.1397V18.8722C49.7676 18.0048 49.0577 17.3045 48.1903 17.3086C46.1017 17.3185 44.4115 19.0148 44.4115 21.1057V28.274C44.2995 28.1137 44.1734 27.9637 44.0349 27.8256C43.6121 27.4054 42.9269 27.4109 42.5053 27.8323L34.8974 35.4403C34.5318 35.8058 34.2418 36.2398 34.044 36.7174C33.8462 37.195 33.7443 37.7069 33.7443 38.2238V41.114",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7476 35.7934L44.0419 32.499C45.3308 31.2102 45.3308 29.1206 44.0419 27.8318C43.6177 27.4076 42.9299 27.4076 42.5057 27.8318L36.0703 34.2672",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2781 25.5406C35.8254 25.5406 37.0797 24.2863 37.0797 22.7391C37.0797 21.1918 35.8254 19.9375 34.2781 19.9375C32.7309 19.9375 31.4766 21.1918 31.4766 22.7391C31.4766 24.2863 32.7309 25.5406 34.2781 25.5406Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7215 25.5406C18.2687 25.5406 19.523 24.2863 19.523 22.7391C19.523 21.1918 18.2687 19.9375 16.7215 19.9375C15.1742 19.9375 13.9199 21.1918 13.9199 22.7391C13.9199 24.2863 15.1742 25.5406 16.7215 25.5406Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4617 29.3297C27.009 29.3297 28.2633 28.0754 28.2633 26.5281C28.2633 24.9809 27.009 23.7266 25.4617 23.7266C23.9145 23.7266 22.6602 24.9809 22.6602 26.5281C22.6602 28.0754 23.9145 29.3297 25.4617 29.3297Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_12758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialSecurity1);
export default __webpack_public_path__ + "static/media/social-security 1.dc9c4ab904408e0696b346e4ee1e8f58.svg";
export { ForwardRef as ReactComponent };